export default __webpack_public_path__ + "static/avatar-aaron-powell-1ba896711ae04a813b1477067c2c81fd.jpg";